import { useMemo, type ReactNode } from 'react';
import { useSessionQuery } from '../api/queries';
import { buildAbility } from '../model/ability';
import { AbilityContext, SessionContext } from '../hooks/sessionContext';

/** La sessione e i permessi che il server ha calcolato per l'utente, per tutta l'app. */
export default function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isPending } = useSessionQuery();
  const user = data ?? null;
  const session = useMemo(() => ({ user, loading: isPending }), [user, isPending]);
  const ability = useMemo(() => buildAbility(user?.rules), [user?.rules]);

  return (
    <SessionContext.Provider value={session}>
      <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
    </SessionContext.Provider>
  );
}
